import React from 'react';

const StatusModal = ({ isOpen, message, success, onClose, title }) => {
  if (!isOpen) return null;

  const renderMessage = () => {
    if (typeof message === "string") {
      return <p className="modal-message">{message}</p>;
    }
    return <div className="modal-message modal-message--custom">{message}</div>;
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className={`modal-status ${success ? "success" : "error"}`}>
          <div className="modal-icon">{success ? "✓" : "×"}</div>
          <h3 className="modal-title">{title || (success ? "Success" : "Notice")}</h3>
          {renderMessage()}
          <button className="modal-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusModal;

